import React from "react";

import { SpotPreview } from "cortex/ui/src/fleet/view/media-library/component/SpotPreview";
import { Media } from "cortex/ui/src/fleet/view/media-library/model";

export function formatPreview(
  url: string,
  mediaEntry: Pick<Media, "mimeType" | "numberOfSpots"> & {
    type?: string | null;
  },
) {
  const { type, mimeType, numberOfSpots } = mediaEntry;

  return (
    <SpotPreview
      mimeType={mimeType ?? undefined}
      numberOfSpots={numberOfSpots ?? undefined}
      type={type ?? undefined}
      url={url ?? undefined}
    />
  );
}
